import { gql } from "gql";

export const APPLICATION_SETTINGS = gql(/*GraphQL*/ `
  query GetAppSettings {
  getApplicationSettings {
    companyName
     mainColor
     accentColor
     languages
     logo {
      link
      }
     }
    }
`);
